import React, { useState } from 'react';
import { useStyles } from 'components/layout/CommonStyles';
import { inputStyles } from './Styles';
import Dropzone from 'react-dropzone';
import Typography from '@material-ui/core/Typography';
import Typography1 from 'components/typography/Typography';
import Clear from '@material-ui/icons/Clear';
import DialogDeleteAttachment from 'components/dialogs/DialogDeleteAttachment';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import axios from 'axios';
import Cookies from 'js-cookie';

import AttachFileIcon from '@material-ui/icons/AttachFile';
import { useSSR, useTranslation } from 'react-i18next';

const InputMultiDropzone = ({
    context,
    files,
    setFiles,
    label,
    required,
    helperText,
    error,
    setRequired,
    setHasChanged,
    ...props
}) => {
    const fileDownload = require('js-file-download');
    const classes = useStyles();
    const styles = inputStyles();
    const [t] = useTranslation();

    const [open, setOpen] = useState(false);
    const [toDeleteFile, setToDeleteFile] = useState(null);

    const onDropFiles = acceptedFiles => {
        if (setHasChanged) {
            setHasChanged(true);
        }
        let newFiles = [];
        let existentFiles = [];

        for (let i = 0; i < acceptedFiles.length; i++) {
            let hasTheSameName =
                files.files.filter(
                    el =>
                        (el.fileName
                            ? el.fileName.toLowerCase()
                            : el.name.toLowerCase()) ===
                        acceptedFiles[i].name.toLowerCase()
                ).length > 0;

            if (hasTheSameName) {
                existentFiles.push(
                    `Arquivo já existente - ${acceptedFiles[i].name}`
                );
            } else {
                newFiles.push(acceptedFiles[i]);
            }
        }

        setFiles({
            ...files,
            files: files.files.concat(newFiles),
            rejectedFiles: files.rejectedFiles.concat(existentFiles)
        });
    };

    function humanFileSize(size) {
        let i = Math.floor(Math.log(size) / Math.log(1024));
        return (
            (size / Math.pow(1024, i)).toFixed(2) * 1 +
            ' ' +
            ['B', 'kB', 'MB', 'GB', 'TB'][i]
        );
    }

    const onClickDownload = async file => {
        if (files && files.files.length > 0) {
            if (file.id) {
                let noSlashPath = file.path.replaceAll('/', ';');
                noSlashPath = noSlashPath.replaceAll('\\', ';');
                const url = process.env.REACT_APP_FILE + noSlashPath;
                axios
                    .get(url, {
                        headers: {
                            'Content-type': 'application/json',
                            Authorization:
                                'bearer ' +
                                (Cookies.get('auth-token')
                                    ? Cookies.get('auth-token')
                                    : '')
                        },
                        responseType: 'blob'
                    })
                    .then(function (res) {
                        const blob = new Blob([res.data], {});
                        const name = file.fileName ? file.fileName : file.name;
                        fileDownload(blob, name);
                    });
            } else {
                fileDownload(file, file.name);
            }
        }
    };

    const handleDelete = data => {
        setToDeleteFile(data);
        setOpen(true);
    };

    const onRemoveFile = data => {
        if (data) {
            let remainingFiles = [];
            let updatedList = [];
            let deletedId;
            if (data.id) {
                deletedId = data.id;
            }

            for (const file of files.files) {
                if (
                    file.path === data.path &&
                    file.lastModified === data.lastModified &&
                    file.size === data.size
                ) {
                    if (file.id) {
                        updatedList = files.rejectedFiles.filter(
                            el =>
                                el !== `Arquivo já existente - ${data.fileName}`
                        );
                    }
                    continue;
                }
                remainingFiles.push(file);
            }
            setFiles({
                ...files,
                files: remainingFiles,
                rejectedFiles: updatedList,
                deletedFiles: deletedId
                    ? [...files.deletedFiles, deletedId]
                    : [...files.deletedFiles]
            });
            if (setHasChanged) {
                setHasChanged(true);
            }
        }
    };

    const deleteRejectedFile = rejectedFile => {
        let updatedList = files.rejectedFiles.filter(el => el !== rejectedFile);
        setFiles({ ...files, rejectedFiles: updatedList });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div>
                <Typography1
                    variant={'RobotoBold'}
                    fontSize={15}
                    textColor={'secondary'}
                >
                    Anexe um documento
                </Typography1>
                {files.rejectedFiles.length > 0 && (
                    <div style={{ paddingBottom: 8 }}>
                        {files.rejectedFiles.map(message => (
                            <div className={classes.dialogFile}>
                                <div className={classes.textFile}>
                                    <Typography1
                                        variant={'RobotoBold'}
                                        fontSize={14}
                                        textColor={'red'}
                                    >
                                        {message}
                                    </Typography1>
                                </div>
                                <div className={classes.iconsFile}>
                                    <IconButton
                                        onClick={() =>
                                            deleteRejectedFile(message)
                                        }
                                    >
                                        <Clear />
                                    </IconButton>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                {files.files.length > 0 ? (
                    <div className={classes.dropzoneDialogFiles}>
                        {files.files.map(file => (
                            <div className={classes.dialogFile}>
                                <div className={classes.textFile}>
                                    <Typography1
                                        variant={'RobotoBold'}
                                        fontSize={14}
                                        textColor={'black'}
                                    >
                                        {file.fileName
                                            ? file.fileName
                                            : file.name}
                                        &nbsp;
                                    </Typography1>
                                    <Typography1
                                        variant={'RobotoRegular'}
                                        fontSize={13}
                                        textColor={'black'}
                                    >{`(${
                                        typeof file.size === 'string' ||
                                        file.size instanceof String
                                            ? file.size
                                            : humanFileSize(file.size)
                                    }  )`}</Typography1>
                                </div>
                                <div className={classes.iconsFile}>
                                    <IconButton
                                        onClick={() => onClickDownload(file)}
                                    >
                                        <GetAppIcon />
                                    </IconButton>
                                    {context !== 'view' && (
                                        <IconButton
                                            onClick={() => handleDelete(file)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={classes.noFilesMessage}>
                        <Typography
                            variant={'h6'}
                            style={{ fontWeight: 'bold' }}
                        >
                            {t('EXPENSES.noFilesMessage')}
                        </Typography>
                        <Typography variant={'caption'}>
                            Os documentos adicionados serão listados aqui
                        </Typography>
                    </div>
                )}
            </div>
            {context !== 'view' && (
                <Dropzone
                    onDrop={onDropFiles}
                    accept="application/pdf,
                                                application/msword,
                                                application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                                image/jpeg,
                                                image/png"
                >
                    {({ getRootProps, getInputProps }) => (
                        <section>
                            <div
                                {...getRootProps({
                                    className: classes.dropzoneDialog
                                })}
                            >
                                <input {...getInputProps()} />
                                <AttachFileIcon color={'primary'} />
                                <Typography1
                                    variant={'RobotoBold'}
                                    fontSize={15}
                                    textColor={'secondary'}
                                >
                                    Arraste e solte os documentos para anexá-los
                                    ou <u>clique aqui</u>
                                </Typography1>
                            </div>
                        </section>
                    )}
                </Dropzone>
            )}
            <DialogDeleteAttachment
                open={open}
                setOpen={setOpen}
                file={toDeleteFile}
                onRemoveFile={onRemoveFile}
            />
        </div>
    );
};

export default InputMultiDropzone;
